import {View, Text} from '@react-pdf/renderer';
import {TFunction} from 'i18next';

import {sharedStyles} from './styles/shared-styles';

interface Props {
  t: TFunction;
  applicantDetails: string;
  description: {
    title: string;
    description: string;
  };
}

export const RecommendationsHeader = ({t, description, applicantDetails}: Props) => {
  return (
    <View style={{marginBottom: 8}}>
      <View style={{marginBottom: 6}}>
        <Text style={{...sharedStyles.h2, marginBottom: 2, fontWeight: 'bold'}}>
          {t('screeningModule.report.recommendations.shared.title')}
        </Text>
        <Text style={sharedStyles.body1}>{applicantDetails}</Text>
      </View>
      <View style={{marginBottom: 6}}>
        <Text style={{...sharedStyles.h3, marginBottom: 2}}>{description.title}</Text>
        <Text style={sharedStyles.body1}>{description.description}</Text>
      </View>
    </View>
  );
};
